<template>
  <div
    class="biChartWrap biLineWrap"
    ref="biLineWrap">
    <svg
      ref="svg"
      v-if="data && data.length"
      :width="clientWidth"
      :height="clientHeight"
      :class="{'biChartBlur': refresh !== 0}">
      <g
        class="area"
        ref="area">
        <g
          class="paths"
          ref="paths"/>
        <g
          class="paths1"
          ref="paths1"/>
        <g
          class="axisX"
          ref="axisX"/>
        <g
          class="axisY"
          ref="axisY"/>
        <g
          class="axisY1"
          ref="axisY1"/>
        <g
          class="focusLine"
          ref="focusLine"
          opacity="0">
          <rect
            :x="left"
            :y="top"
            :width="innerWidth"
            :height="innerHeight"
            @mouseover="opacityFocus(1)"
            @mouseout="opacityFocus(0)"
            @mousemove="inventFocus"/>
          <line
            :x1="focus.focusX"
            :y1="top"
            :x2="focus.focusX"
            :y2="bottom"/>
          <g
            v-if="classes.data.length"
            v-for="(item, index) in classes.data"
            :key="index"
            :opacity="classes.data[index].status ? 1 : 0">
            <circle
              :cx="focus.focusX"
              :cy="focus.focusY[index]"
              :fill="colors[index]"
              r="4"
              stroke-width="1.5"/>
          </g>
        </g>
      </g>
      <bi-label
        :data="classes.data"
        :options="classes.options"
        @classesClick="classesClick"/>
      <defs>
        <clipPath :id="hashId">
          <rect
            :width="innerWidth + 2"
            :height="innerHeight + 1"
            :x="left"
            :y="top - 1"/>
        </clipPath>
      </defs>
    </svg>
    <div
      class="center-p"
      v-show="refresh === 0 && !(classes.data.length) || refresh === 1 || refresh === 2 || refresh === 3">
      <el-tag type="warning"><i
        class="el-icon-loading"
        v-show="refresh === 1"/>{{ message[refresh] }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="reload"
        v-show="refresh === 0">
        <i class="el-icon-refresh"/>点击刷新
      </el-button>
    </div>
    <bi-tool-tip
      class="tooltip"
      ref="tooltip"
      :data="tooltip"/>
  </div>
</template>

<script>
import * as d3 from 'd3';
import Common from '@/components/charts/common';

export default {
  mixins: [Common],
  data() {
    return {
      init: false,
      defaultOptions: {
        width: 0,
        height: 0,
        margin: {
          top: 50, right: 24, bottom: 20, left: 45
        },
        domainType: 'number',
        tooltipType: 'string',
        domainX: [],
        domainY: [],
        domainY1: [],
        curve: 'curveLinear',
        duration: 400,
        timeFormat: '%Y-%m-%d',
        labelWidthPercent: 25,
        isArea: 0,
        exY: '',
        exY1: '',
      },
      focus: {
        focusX: 0,
        focusY: [],
      },
    };
  },
  props: {
  },
  computed: {
    // dataFormat() {
    //   return this.data.map((i) => {
    //     // i.list.forEach((o) => {
    //     //   o.label = new Date(o.label);
    //     // });
    //     return i;
    //   });
    // },
    // screen() {
    //   let data = [];
    //   this.dataFormat.forEach((d, i) => this.classes.data[i].status && data.push(d));
    //   return data;
    // },
    datum() {
      let data = [];
      this.data.forEach((item) => {
        if (this.getLabelStatus(item.title, this.classes.data)) {
          data.push(item.list);
        }
      });
      return d3.merge(data);
    },
    scaleX() {
      let scale;
      switch (this.option.domainType) {
        case 'time':
          scale = d3.scaleTime()
            .domain(this.domainX.map(i => new Date(`${i} 0:0:0`)));
          break;
        default:
          scale = d3.scaleLinear()
            .domain(this.domainX);
      }
      return scale
        .range([this.left, this.right]);
    },
    scaleY() {
      return d3.scaleLinear().range([this.bottom, this.top]).domain(this.domainY);
    },
    scaleY1() {
      let domain = this.option.domainY1.length ? this.option.domainY1 : this.domainY;
      return d3.scaleLinear().range([this.bottom, this.top]).domain(domain);
    },
    domainX() {
      let data = [];
      this.data.forEach((item) => {
        data.push(item.list);
      });
      return d3.extent(d3.merge(data), d => d.label);
    },
    domainY() {
      let data = [];
      if (!data.length) {
        this.data.forEach((item) => {
          data.push(item.list);
        });
        data = d3.merge(data);
      }
      return d3.extent(data, d => d.value);
    },
    domainY1() {
      let data = [];
      if (!data.length) {
        this.data1.forEach((item) => {
          data.push(item.list);
        });
        data = d3.merge(data);
      }
      return d3.extent(data, d => d.value);
    },
    line1() {
      let lines = d3.line();
      lines
        .x(d => this.scaleX(this.option.domainType === 'time' ? new Date(`${d.label} 0:0:0`) : d.label))
        .y(this.bottom);
      return lines;
    },
    line() {
      let lines = d3.line();
      lines
        .x((d) => {
          // console.log(1, this.option.domainType === 'time' ? new Date(d.label) : d.label);
          return this.scaleX(this.option.domainType === 'time' ? new Date(`${d.label} 0:0:0`) : d.label);
        })
        .y(d => this.scaleY(d.value));
      return lines;
    },
    line2() {
      let lines = d3.line();
      lines
        .x((d) => {
          return this.scaleX(this.option.domainType === 'time' ? new Date(`${d.label} 0:0:0`) : d.label);
        })
        .y((d) => {
          return this.scaleY1(d.value);
        });
      return lines;
    },
    area1() {
      let area = d3.area();
      area
        .x(d => this.scaleX(this.option.domainType === 'time' ? new Date(`${d.label} 0:0:0`) : d.label))
        .y0(this.bottom)
        .y1(this.bottom);
      return area;
    },
    area() {
      let area = d3.area();
      area
        .x(d => this.scaleX(this.option.domainType === 'time' ? new Date(`${d.label} 0:0:0`) : d.label))
        .y0(this.bottom)
        .y1(d => this.scaleY(d.value));
      return area;
    },
    curve() {
      return this.option.curve;
    }
  },
  methods: {
    inventLines() {
      d3
        .select(this.$refs.paths)
        .selectAll('path')
        .remove();

      let lines = d3
        .select(this.$refs.paths)
        .selectAll('path')
        .data(this.data);

      let enter = lines.enter();
      let exit = lines.exit();

      enter
        .append('path')
        .attr('class', 'line')
        .datum(d => d.list)
        .attr('fill', 'none')
        .attr('stroke', (d, i) => this.getColor(this.data[i].title, this.classes.data))
        .attr('stroke-width', 1.5)
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('clip-path', `url(#${this.hashId})`)
        .attr('d', this.line1)
        .transition()
        .duration(this.duration)
        .attr('d', this.line)
        .attr('opacity', (d, i) => {
          return this.getLabelStatus(this.data[i].title, this.classes.data) ? 1 : 0;
        })
        .ease(d3.easeElastic);
      if (this.option.isArea) {
        // 区域绘画
        enter
          .append('path')
          .attr('class', 'area')
          .datum((d) => {
            let list = [{ label: d.list[0].label, value: 0 }];
            list = list.concat(d.list);
            let end = [{ label: d.list[d.list.length - 1].label, value: 0 }];
            list = list.concat(end);
            return list;
          })
          .attr('fill', (d, i) => this.getColor(this.data[i].title, this.classes.data))
          .attr('stroke-linejoin', 'round')
          .attr('stroke-linecap', 'round')
          .attr('clip-path', `url(#${this.hashId})`)
          .attr('d', this.line1)
          .transition()
          .duration(this.duration)
          .attr('d', !this.option.isArea ? this.line : this.area)
          .attr('opacity', (d, i) => {
            return this.getLabelStatus(this.data[i].title, this.classes.data) ? 0.5 : 0;
          })
          .ease(d3.easeElastic);
      }
      if (this.data1.length) {
        // 第二数据区的绘画
        d3
          .select(this.$refs.paths1)
          .selectAll('path')
          .remove();
        let lines1 = d3
          .select(this.$refs.paths1)
          .selectAll('path')
          .data(this.data1);
        let enter1 = lines1.enter();
        enter1
          .append('path')
          .attr('class', 'line')
          .datum(d => d.list)
          .attr('fill', 'none')
          .attr('stroke', (d, i) => this.getColor(this.data1[i].title, this.classes.data))
          .attr('stroke-width', 2)
          .attr('stroke-linejoin', 'round')
          .attr('stroke-linecap', 'round')
          .attr('clip-path', `url(#${this.hashId})`)
          .attr('d', this.line1)
          .attr('style', 'stroke-dasharray:5;stroke-dashoffset:1')
          .transition()
          .duration(this.duration)
          .attr('d', this.line2)
          .attr('opacity', (d, i) => {
            return this.getLabelStatus(this.data1[i].title, this.classes.data) ? 1 : 0;
          })
          .ease(d3.easeElastic);
        if (this.option.domainY1.length) {
          // 第二条Y轴的绘画
          let axisY1 = d3.select(this.$refs.axisY1)
            .attr('transform', `translate(${this.right}, 0)`)
            .call(d3.axisRight(this.scaleY1).ticks(10).tickFormat(d => d * 100));
          if (this.option.exY1) {
            axisY1
              .append('text')
              .attr('fill', '#000')
              .attr('y', this.top)
              .attr('dx', -5)
              .attr('dy', 5)
              .attr('text-anchor', 'end')
              .text(`单位 ${this.option.exY1}`);
          }
        }
      }

      exit
        .attr('opacity', 1)
        .transition()
        .duration(this.duration)
        .attr('opacity', 0)
        .remove();

      this.calculateAxis();
      this.$emit('update:refresh', false);
    },
    initializeLine() {
      if (this.data.length === 0) return;
      this.inventLines();
    },
    opacityFocus(opacity) {
      d3
        .select(this.$refs.focusLine)
        .transition()
        .duration(this.duration / 2)
        .attr('opacity', opacity || 0);
      d3
        .select(this.$refs.biLineWrap)
        .select('.tooltip')
        .transition()
        .duration(this.duration / 2)
        .style('opacity', opacity || 0);
    },
    inventFocus(e) {
      let scaleX = this.scaleX;
      let data = this.data[0].list;

      let mouseX = e.layerX;
      let x0 = scaleX.invert(mouseX - (this.dataWidth / data.length / 2));

      let bisect = d3.bisector(d => this.formatLabel(d.label)).left;

      let index = bisect(data, x0);
      this.tooltip = {
        panelWidth: this.innerWidth,
        desc: []
      };
      this.focus.focusX = scaleX(this.formatLabel(data[index].label));
      this.focus.focusY = [];
      this.data.forEach((d) => {
        let y1 = d.list[index].value;
        let label = this.getLabel(d.title, this.classes.data);
        if (label.status) {
          label.value = (this.option.exY && this.option.exY === '%') ? `${(y1 * 100).toFixed(2)}` : y1;
          label.value += this.option.exY;
          this.tooltip.desc.push(label);
        }
        this.focus.focusY.push(this.scaleY(y1));
      });
      this.data1.forEach((d) => {
        let y2 = d.list[index].value;
        let label = this.getLabel(d.title, this.classes.data);
        if (label.status) {
          label.value = (this.option.exY1 && this.option.exY1 === '%') ? `${(y2 * 100).toFixed(2)}` : y2;
          label.value += this.option.exY1 === '' ? this.option.exY : this.option.exY1;
          this.tooltip.desc.push(label);
        }
        this.focus.focusY.push(this.scaleY1(y2));
      });
      this.tooltip.x = e.layerX;
      this.tooltip.y = e.layerY;
      let weekday = [];
      weekday[0] = '星期天';
      weekday[1] = '星期一';
      weekday[2] = '星期二';
      weekday[3] = '星期三';
      weekday[4] = '星期四';
      weekday[5] = '星期五';
      weekday[6] = '星期六';
      let label = data[index].label;
      let dateFormat = [];
      switch (this.option.tooltipType) {
        case 'day':
          label = new Date(label);
          dateFormat = d3.timeFormat('%Y-%m-%d');
          this.tooltip.title = `${dateFormat(label.getTime())} ${weekday[label.getDay()]}`;
          break;
        case 'month':
          label = new Date(label);
          dateFormat = d3.timeFormat('%Y年%m月');
          this.tooltip.title = dateFormat(label.getTime());
          break;
        case 'year':
          label = new Date(label);
          dateFormat = d3.timeFormat('%Y年');
          this.tooltip.title = dateFormat(label.getTime());
          break;
        default:
          this.tooltip.title = label;
      }
    },
    calculateAxis(boolean = true) {
      let dMax = new Date(`${this.option.domainX[1]} 0:0:0`).getTime();
      let dMin = new Date(`${this.option.domainX[0]} 0:0:0`).getTime();
      const days = ((dMax - dMin) / 86400000) | 0;
      let formatStr = '%y-%m';
      let iDay = (days / 5) | 0;
      let tick = d3.timeDay.every(iDay);
      if (days < 100) {
        formatStr = '%y-%m-%d';
      } else if (days > 366) {
        formatStr = '%Y';
        tick = d3.timeYear.every(1);
      } else {
        tick = d3.timeMonth.every(1);
      }

      boolean && d3
        .select(this.$refs.axisX)
        .attr('transform', `translate(0, ${this.bottom})`)
        .transition()
        .duration(this.duration)
        .call(d3.axisBottom(this.scaleX)
          .ticks(tick)
          .tickFormat(d3.timeFormat(formatStr)));

      tick = this.domainY[1];
      let axisY = d3.select(this.$refs.axisY)
        .attr('transform', `translate(${this.left}, 0)`)
        .call(d3
          .axisLeft(this.scaleY)
          .ticks(tick > 2 ? 5 : tick)
          .tickFormat((d) => {
            d = this.option.exY === '%' ? d * 100 : d;
            return `${d}`;
            // return `${d}${this.option.exY}`;
          }));
      // 如果exY存在则右侧纵轴有单位
      if (this.option.exY) {
        axisY
          .append('text')
          .attr('fill', '#000')
          .attr('y', this.top)
          .attr('dx', 5)
          .attr('dy', 5)
          .attr('text-anchor', 'start')
          .text(`单位 ${this.option.exY}`);
      }
    },
    classesClick(ix) {
      this.classes = Object.assign({}, this.classes, {
        data: this.changeClassStatus(ix, this.classes.data)
      });
      let isView = 1;
      isView = d3.max(this.classes.data.map((i) => { return i.status; }));
      d3
        .select(this.$refs.area)
        .transition()
        .duration(this.duration)
        .attr('opacity', isView === 0 ? 0 : 1);
      if (this.data.length > ix) {
        d3
          .select(this.$refs.paths)
          .selectAll('.line')
          .each((d, i, t) => {
            d3
              .select(t[i])
              .transition()
              .duration(this.duration)
              .style('opacity', () => {
                return this.getLabelStatus(this.data[i].title, this.classes.data) ? 1 : 0;
              })
              .attr('d', this.line)
              .ease(d3.easeElastic);
          });
        d3
          .select(this.$refs.paths)
          .selectAll('.area')
          .each((d, i, t) => {
            d3
              .select(t[i])
              .transition()
              .duration(this.duration)
              .style('opacity', () => {
                return this.getLabelStatus(this.data[i].title, this.classes.data) ? 0.5 : 0;
              })
              .attr('d', this.line);
          });
      } else {
        d3
          .select(this.$refs.paths1)
          .selectAll('.line')
          .each((d, i, t) => {
            d3
              .select(t[i])
              .transition()
              .duration(this.duration)
              .style('opacity', () => {
                return this.getLabelStatus(this.data1[i].title, this.classes.data) ? 1 : 0;
              })
              .attr('d', this.line2)
              .ease(d3.easeElastic);
          });
      }
      this.calculateAxis(false);
    },
    formatLabel(label) {
      if (this.option.domainType === 'time') {
        return new Date(`${label} 0:0:0`);
      }
      return label;
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        if (this.option.classes) {
          this.classes.data = this.option.classes.map((d, i) => {
            return {
              title: d,
              color: this.colors[i],
              type: 'line',
              status: true,
              view: true
            };
          });
          this.classes.options = {
            panelWidth: this.clientWidth,
            labelWidthPercent: this.option.labelWidthPercent
          };
          if (this.option.classes1) {
            let classes1 = this.option.classes1;
            for (let i = classes1.length - 1; i >= 0; i--) {
              let index = (i + this.option.classes.length) % this.colors.length;
              this.classes.data.push({
                title: classes1[i],
                color: this.colors[index],
                type: 'dotLine',
                status: true,
                view: true
              });
            }
          }
        }
        if (!this.init) {
          this.initializeLine();
          this.init = true;
        } else {
          this.inventLines();
        }
      });
    }
  }
};
</script>

<style>
.biLineWrap {
  position: relative;
  height: 100%;
}

.biChartBlur {
  opacity: .25;
  filter: blur(12px);
}

.biLineWrap svg {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.biLineWrap line {
  shape-rendering: crispEdges;
}

.biLineWrap .axis path,
.biLineWrap .axis line {
  fill: none;
  stroke: black;
  shape-rendering: crispEdges;
}

.biLineWrap .focusLine rect {
  fill: none;
  pointer-events: all;
}

.biLineWrap .focusLine line {
  stroke: #666;
  stroke-dasharray: 2, 1;
  pointer-events: none;
}

.biLineWrap .focusLine circle {
  stroke: #333;
  pointer-events: none;
}

.biLineWrap .center-p {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
